const dailyNotificationMessages = {
  "MENSTRUATION_1": "Your period is due today. Don't forget to login the dates on the tracker for personalised diet recommendations",
  "FOLLICULAR_1": "Your period is due today. Don't forget to login the dates on the tracker for personalised diet recommendations"
}

export default dailyNotificationMessages;